/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import SvgCaretDown from '@digital-hig/icon/lib/build/ui-controls/caret-down';
import SvgCaretUp from '@digital-hig/icon/lib/build/ui-controls/caret-up';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import CompanyRootElement from '../CompanyInformation/style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { DEFAULT_ACCORDION_SIZE, VIEW_SERVICES_ACCORDION } from '../../../constants/app-constants';
import AccordionList, { isItemAvailableInside } from '../../../common/accordionList';

const Services = ({ profileDetails, loading, scrollRef }) => {
  const { services } = profileDetails || {};
  const [toggleShow, setToggleShow] = useState(false);
  const { t } = useTranslation();
  const param = useParams();
  let isValidItems = false;
  if (services) {
    isValidItems = Object.keys(services).map((item) => isItemAvailableInside(item, services)).includes(true);
  }
  return (
    // eslint-disable-next-line
    <CompanyRootElement ref={(el) => (scrollRef.current[2] = el)}>
      {isValidItems && (
        <Box className="page-container">
          <Typography variant="headline-medium" mb={2} component="h3">
            {t('Services')}
          </Typography>
          <Typography variant="body-copy-medium" mb={7} className="sub-description">
            {t('A comprehensive view of the services our Partners offer and report to Autodesk, ensuring you have access to the highest quality solutions tailored to your needs.')}
          </Typography>
          <AccordionList
            dataWatLoc="services"
            items={toggleShow ? services : Object.fromEntries(Object.entries(services || {}).slice(0, VIEW_SERVICES_ACCORDION))}
            loading={loading}
            size={DEFAULT_ACCORDION_SIZE}
          />
          {!loading && (
            <Typography
              onClick={() => setToggleShow(!toggleShow)}
              variant="headline-smaller"
              className="see-more-button"
            >
              {toggleShow ? (
                <>
                  {t('See less')}
                  {param.locale !== 'jp' && (
                    <>
                      {' '}
                      {t('Services')}
                    </>
                  )}
                  <SvgCaretUp width="12px" />
                  {' '}
                </>
              ) : (
                <>
                  {t('See more')}
                  {param.locale !== 'jp' && (
                    <>
                      {' '}
                      {t('Services')}
                    </>
                  )}
                  <SvgCaretDown width="12px" />
                </>
              )}
            </Typography>
          )}
          {loading && (
            <Typography variant="headline-smaller">
              <Skeleton width="15%" />
            </Typography>
          )}
        </Box>
      )}
    </CompanyRootElement>
  );
};

Services.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
  scrollRef: PropTypes.shape({}),
};
Services.defaultProps = {
  profileDetails: {},
  loading: false,
  scrollRef: {},
};
export default ProfileContextConsumer(Services);
